import React from 'react';
import { Translation } from 'react-i18next';
import { Typography, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { PlusOutlined } from '@ant-design/icons';
import { pathTo } from '../../../Routes';
import QueryString from '../../../../../lib/QueryString';

const { Title, Text } = Typography;

const LearningAdminHeaderList = ({
  partnershipId,
  history,
  component,
  view,
  activeKey,
  module,
  trackerActions,
  ...props
}) => {
  const addComponentModule = () => {
    history.push(
      QueryString.append(
        pathTo(component, {
          id_partnership: partnershipId,
        }),
        { view, key: activeKey }
      )
    );
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div
            style={{
              padding: '30px',
              backgroundColor: '#e3f2fd',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <Title level={4} className='learning-title'>
                {t(`learning_admin_header_list_title_${module}`)}
              </Title>
              <Text>
                {t(
                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
                )}
              </Text>
            </div>
            <Button
              onClick={(e) => addComponentModule()}
              type='primary'
              size='large'
              icon={<PlusOutlined />}
              style={{ marginLeft: '40px' }}
            >
              {t(`learning_admin_header_list_button_${module}`)}
            </Button>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminHeaderList);

Logger.log('silly', `LearningAdminHeaderList loaded.`);
